import { render, staticRenderFns } from "./epms5020.vue?vue&type=template&id=59c5cef4&scoped=true"
import script from "./epms5020.vue?vue&type=script&lang=js"
export * from "./epms5020.vue?vue&type=script&lang=js"
import style0 from "./epms5020.vue?vue&type=style&index=0&id=59c5cef4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c5cef4",
  null
  
)

export default component.exports